<template>
  <div>
    <div v-show="!edit && !saving">
      <div v-if="!hours && !showRaw">-</div>
      <div v-if="showRaw">{{ hours }}</div>
      <!--      <span @click="editDuration()" class="duration-number">{{ hours }}</span>-->
      <div v-if="hours && !showRaw" @click="editDuration()">
        <input
            type="text"
            class="form-control pointer"
            v-model="hours"
            style="width: 50%;"
            placeholder="01:00"
        >
      </div>
    </div>
    <div v-show="edit && !saving" style="display: flex; align-items: center;">
      <input ref="input" type="text" class="form-control" v-model="hours" style="width: 50%;" placeholder="01:00"
             @keyup.enter="save()">
      <div @click="save()" class="ml-1 btn btn-jet">
        <i class="fas fa-save"></i>
      </div>
      <div @click="cancel()" class="ml-1 btn btn-jet">
        <i class="fas fa-times"></i>
      </div>
    </div>
    <div v-if="saving" class="btn btn-jet">
      <i class="fas fa-sync fa-spin"></i>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    task: {},
    field: {},
    allowEditNull: {},
    showRaw: {}
  },
  created() {
    this.hours = this.task[this.field] ? this.$root.formatIntegerSecondsToReadable(this.task[this.field], true) : null
    if (this.hours === null && this.allowEditNull) {
      this.hours = '00:00'
    }
  },
  data() {
    return {
      edit: false,
      hours: null,
      saving: false,
    }
  },
  methods: {
    editDuration() {
      this.edit = true
      this.$nextTick(() => {
        this.$refs['input'].focus()
      })
    },
    save() {
      this.saving = true

      let payload = {
        task_id: this.task.id,
      }
      payload[this.field] = this.hours

      this.axios.post('/n/tasks/update-hours', payload).then(response => {
        this.edit = false
        if (response.data.data[this.field]) {
          this.task[this.field] = response.data.data[this.field]
          this.hours = this.$root.formatIntegerSecondsToReadable(this.task[this.field], true)
        }
        this.$root.$emit('Tasks::updated', {task: response.data.data})
      }).finally(() => {
        this.saving = false
      })
    },
    cancel() {
      this.hours = this.$root.formatIntegerSecondsToReadable(this.task[this.field], true)
      this.edit = false
    }
  }
}
</script>
<style lang="scss">
.duration-number {
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/agenda-v2/small-task-modal/hour-edit.vue